module.exports = __webpack_public_path__ + "static/media/satagro_tool_en.ca678697.png";